import {
  Alert,
  AlertIcon,
  CloseButton,
  AlertTitle,
  AlertDescription,
  useDisclosure,
  Center,
} from "@chakra-ui/react";
import Link from "next/link";
import { useAuth } from "@/utils/auth";
export function AAlert() {
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const { user } = useAuth();

  return (
    <>
      {!user ? (
        isOpen && (
          <Alert
            status="info"
            justifyContent="center"
            textAlign="center"
            variant="top-accent"
          >
            <AlertIcon />
            <AlertTitle me={1}>You are not logged in !</AlertTitle>
            <AlertDescription bg="cyan.300" p={1} borderRadius={3}>
              <Link href="/Auth/">Join Axenda</Link>
            </AlertDescription>
            <CloseButton
              position="static"
              insetEnd={[3, 4, 5, 6]}
              onClick={onClose}
            />
          </Alert>
        )
      ) : (
        <Center alignItems="center">
          {user.admin ? "Welcome Admin" : "Hi"}{" "}
        </Center>
      )}
    </>
  );
}
